import * as React from "react";
const SvgSeperator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 2, height: 32, viewBox: "0 0 2 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 2, height: 32, rx: 1, fill: "white" }));
export default SvgSeperator;
